import { observer } from "mobx-react";
import React, { useState } from "react";
import { PoolData } from "types";
import DepositWithdrawClaim from "./DepositWithdrawClaim";
import Multipliers from "./Multipliers";
import "./UserInteractions.scss";

type Props = {
  pool: PoolData;
};

function UserInteractions({ pool }: Props) {
  const [view, setView] = useState<number>(0);

  const views = {
    0: <DepositWithdrawClaim pool={pool} />,
    1: <Multipliers pool={pool} />,
  };

  return (
    <div className="section-interactions">
      <div className={`section-title clickable section-title-interactions ${view === 0 && "active"}`} onClick={() => setView(0)}>
        Interactions
      </div>
      <div className={`section-title clickable section-title-interactions boosts ${view === 1 && "active"}`} onClick={() => setView(1)}>
        Boost with RAM
      </div>
      {views[view]}
    </div>
  );
}

export default observer(UserInteractions);
